import { Box, Button, Checkbox, FormControlLabel, Link, Typography } from '@mui/material'
import React from 'react'
import { useNurse } from 'contexts/NurseProvider'
import { useAPI } from 'contexts/APIProvider'
import NurseProfileError from 'errors/NurseProfileError'
import { useSnackBarAlert } from 'contexts/SnackBarAlertProvider'
import { nurseJobsURL } from 'routes/urls'
import { SUPPORT_PHONE_NUMBER } from 'types/constants'

const NurseContractAgreement: React.FC = () => {
  const { nurse } = useNurse()
  const { api } = useAPI()
  const { showAlert } = useSnackBarAlert()
  const [loading, setLoading] = React.useState<boolean>(false)
  const [agreed, setAgreed] = React.useState<boolean>(false)

  async function agree() {
    if (nurse) {
      try {
        setLoading(true)
        await api.editNurse({ agreed_contracts: true }, nurse?.nurse_id)
        await api.createContractAgreement({ nurse_id: nurse.nurse_id })
        window.location.replace(nurseJobsURL(nurse.nurse_id));
      } catch (e: any) {
        if (e instanceof NurseProfileError) {
          showAlert('error', 'You must agree to our terms and conditions if you wish to work with us.')
        } else {
          console.error('unhandled exception', e)
        }
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, maxWidth: ['100%', '60%'], margin: 'auto' }}>
      <Typography variant='h1'>We have updated our terms and conditions. </Typography>
      <Link href='https://www.locumloop.com/agreements-locum' target='_blank' rel='noopener noreferrer'>Review the contracts here</Link>
      <FormControlLabel
        control={<Checkbox checked={agreed} onChange={(e) => setAgreed(e.target.checked)} />}
        label='I have read and agree to the Terms and Conditions'
      />
      <Button
        variant='contained'
        onClick={agree}
        disabled={loading || !agreed}>
          {loading ? 'Please Wait ...' : 'I Agree'}
      </Button>
      <Typography variant='body2'>
        Questions? Contact us at hello@locumloop.com or {SUPPORT_PHONE_NUMBER}
      </Typography>
    </Box>
  )
}

export default NurseContractAgreement